module.exports = __webpack_public_path__ + "img/75ne.f4ae89e2.svg";